import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
    AddDiscountAPI,
  getFoodCategoryApi,
  getSupermarketCategoryApi,
  getSupplierListApi,
} from "../../../../Api/PanelAdminServices";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import Select from "react-select";
import Style from "./OneCategoryDiscountContainer.module.scss";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
const OneCategoryDiscountContainer = () => {
  const [loadingType, setLoadingType] = useState(true);
  const [isDisableCategory, setisDisableCategory] = useState(true);
  const [suppliersState, setSuppliersState] = useState(null);
  const [supplierSelectState, setSupplierSelect] = useState(null);
  const [ResturanCategoryState, setResturanCategoryState] = useState(null);
  const [SupperMarketCategoryState, setSupperMarketCategoryState] =useState(null);
  const [DiscountType, setDiscountType] = useState(null);
  const [categorySelect, setCategorySelect] = useState(null);
  const [disable, setDisable] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onsubmit = (data) => {
    setDisable(true)
    let info = {
      id: categorySelect.value,
      product_id: 0,
      supplier_id: supplierSelectState.value,
        const: data.CountDiscount===undefined?0:data.CountDiscount,
        precentage:data.PrecentDiscount===undefined?0:data.PrecentDiscount
    };
    AddDiscountAPI(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        setDisable(false)
      } else {
        errorToast(succ.message);
        setDisable(false)
        }
      })
  };
  useEffect(() => {
    getAllSupplierData();
  }, []);
  const getAllSupplierData = async () => {
    getSupplierListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setSuppliersState(res.suppliers)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
    setLoadingType(false);
  };
  const SupplierChangeHandler = async (value) => {
    setisDisableCategory(false);
    setSupplierSelect(value)
    if (value.label.split(" ").at(-1) === "(رستوران)") {
      getFoodCategoryApi(value.value,(succ,res)=>{
        if(succ){
          if(res.status===0){
            errorToast("مشکلی پیش آمده است")
          }else{
            setResturanCategoryState(res.category);
            setSupperMarketCategoryState(null);
          }
        }else{
          errorToast("خطایی در سرور رخ داده است")
        }
      })
    } else {
      getSupermarketCategoryApi((succ,res)=>{
        if(succ){
          if(res.status===0){
            errorToast("مشکلی پیش آمده است")
          }else{
            setSupperMarketCategoryState(res.category);
            setResturanCategoryState(null);
          }
        }else{
          errorToast("خطایی در سرور رخ داده است")
        }
      })
    }
  };
  const CategoryChangeHandler=(value)=>{
      setCategorySelect(value)
  }
  const DiscountTypeChangeHandler = (e) => {
    setDiscountType(e.target.value);

  };
  return (
    <div className={Style.componentHolder}>
      <TableFixedPage title={"ایجاد تخفیف روی یک دسته بندی"} />
      <div className={Style.imgHolder}>
        <img src="/Assets/Images/assignProduct/restaurant.svg" alt="" />
      </div>
      <form onSubmit={handleSubmit(onsubmit)} className={Style.formPart}>
        <div className={Style.inputHolder}>
          <Select
            options={
              suppliersState &&
              suppliersState.map((item) => {
                return {
                  value: item.id,
                  label: `${item.name} ${
                    item.type === "supermarket" ? "(سوپرمارکت)" : "(رستوران)"
                  }`,
                };
              })
            }
            className={Style.selectOptionsearch}
            placeholder={"تامین کننده"}
            onChange={SupplierChangeHandler}
            isLoading={loadingType}
          />
          <Select
            options={
              ResturanCategoryState !== null
                ? ResturanCategoryState.map((item) => {
                    return {
                      value: item.id,
                      label: item.category,
                    };
                  })
                : SupperMarketCategoryState &&
                  SupperMarketCategoryState.map((item) => {
                    return {
                      value: item.id,
                      label: item.category,
                    };
                  })
            }
            className={Style.selectOptionsearch}
            placeholder={"دسته بندی"}
            onChange={CategoryChangeHandler}
            isDisabled={isDisableCategory}
          />

          <select
            name=""
            id=""
            className={errors.maxCount ? Style.errorInput : Style.inputPart}
            onChange={DiscountTypeChangeHandler}
            
          >
            <option value="0">نوع تخفیف انتخاب کنید</option>
            <option value="2">درصد</option>
            <option value="1">مقدار</option>
          </select>
          {DiscountType === "1" ? (
            <input
              className={errors.maxCount ? Style.errorInput : Style.inputPart}
              placeholder={"مقدار تخفیف"}
              {...register("CountDiscount", { required: true })}
            />
          ) : DiscountType === "2" ? (
            <input
              className={errors.price ? Style.errorInput : Style.inputPart}
              placeholder={"درصد تخفیف"}
              {...register("PrecentDiscount", { required: true })}
            />
          ) : null}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <button className={Style.btnStyle} type={"submit"} disabled={disable}>
            ثبت
          </button>
        </div>
      </form>
    </div>
  );
};

export default OneCategoryDiscountContainer;
